<template>
<div class="md:flex flex-wrap min-h-screen">




  <div class="bg-white md:fixed top-0 left-0 w-full h-20 flex items-center botborder z-10 relative">
    <div v-if="$route.name === 'addnew' || $route.name === 'addnewclient'" class="md:absolute md:ml-10 lg:ml-24 mt-2 ml-2 md:ml-0 md:mt-0 "><a href="" @click.prevent="$router.push('/dash/home')">< Back to dashboard</a>
      <div class="inline-block" v-if="$route.name !== 'addnewclient'">
      <span v-if="$store.getters['dash/agency'].isAgency">
      <div class="inline-block ml-3" v-if="!$store.getters['dash/agency'].isClientName">
        <span class="text-sm uppercase">| {{ $store.getters['dash/agency'].agencyName }}</span>
      </div>
      <div class="inline-block ml-3" v-else>
        <span class="text-sm uppercase">| {{ $store.getters['dash/agency'].isClientName }}</span>
      </div>
      </span>
      </div>
    </div>
    <img v-if="$store.state.dash.logoURL"  class="pt_logo w-48 block mx-auto" :src="$store.state.dash.logoURL"/>
    <img v-else  class="w-48 block mx-auto" src="@/assets/images/logo/logo.png"/>
  </div>

  <div class="w-full py-6 md:pt-18 md:w-118 lg:w-200 bg-white md:shadow-setupside px-8 lg:px-20 min-h-full">
    <transition :name="'fade-2x'" mode="out-in">
      <keep-alive>
        <component :is="currentInputComponent" v-on:next="nextCalled" v-on:back="backCalled" :key="step"/>
      </keep-alive>
    </transition>
  </div>

  <div class="w-full py-8 md:py-0 md:fixed md:w-full md:top-20 md:pl-118 lg:pl-200 md:pb-20 md:min-h-full z-m1 md:flex icnbg items-center bgcolortransition" :style="{backgroundColor: asideBGColor}">
    <transition :name="'fade-s'" mode="out-in">
      <component :is="currentAsideComponent" />
    </transition>
  </div>

  <vs-prompt
      @accept="createNewEntity"
      :active.sync="showRetryAppSumoCode"
      title="AppSumo Code">
      <div class="con-exemple-prompt">
        <p class="my-5 text-primary">It seems like you've entered an invalid AppSumo redemption code.</p>
        <span>Please carefully re-enter your AppSumo redemption code:</span>
        <vs-input placeholder="Code" v-model.trim="retryAppSumoCode" class="my-3 w-full" />
        <p class="my-5">If you can't get your code to work, please let us know at <a href="mailto:support@feedback.link">support@feedback.link</a></p>
      </div>
  </vs-prompt>

</div>
</template>

<script>

import {
  auth
} from '../../firebase/firebaseConfig.js'

import themeConfig from '@/../themeConfig.js'

import step1inputs from './step1/inputs.vue'
import step1aside from './step1/aside.vue'

import step2inputs from './step2/inputs.vue'
import step2aside from './step2/aside.vue'

import step3inputs from './step3/inputs.vue'
import step3aside from './step3/aside.vue'

import { signUp, addNewLocation } from '@/firebase/firebaseConfig.js'

function scrollTo(element, to, duration) {
    if (duration <= 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;

    setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        scrollTo(element, to, duration - 10);
    }, 10);
}


export default {

  data () {
    return {
      step: 1,
      transitionName: themeConfig.routerTransition,
      retryAppSumoCode: '',
      showRetryAppSumoCode: false
    }
  },
  components: {
    step1inputs,
    step1aside,
    step2inputs,
    step2aside,
    step3inputs,
    step3aside
  },
  computed: {
    currentInputComponent () {
      return 'step' + this.step + 'inputs'
    },
    currentAsideComponent () {
      return 'step' + this.step + 'aside'
    },
    asideBGColor () {
      switch (this.step) {
        case 1:
          return '#FBEFFF'
        break;
        case 2:
          return '#F2EDFF'
        break;
        case 3:
          return '#F2FAFF'
        break;
      }
    }
  },
  methods: {
    createNewEntity() {

      let isAgencyAddingClient = false
      if (this.$route.name === 'addnewclient' && this.$store.state.dash.loggedInUser.agency) {
        //noconsoleconsole.log('is agency adding new client')
        isAgencyAddingClient = this.$store.state.signUpState.recorded.agencyInfo.clientBrandName
      }

      let currentUser = this.$store.state.auth.firebaseUser
      let userID = currentUser.uid
      let genBusId = this.genRandomUID(userID) + (new Date()).getTime()

      let userInfo = {
        firstName: this.$store.state.signUpState.recorded.mainUser.firstName,
        lastName: this.$store.state.signUpState.recorded.mainUser.lastName,
        contactNumber: this.$store.state.signUpState.recorded.mainUser.contactNumber,
        emailAddress: this.$store.state.signUpState.recorded.mainUser.emailAddress
      }

      let entityDetail = {
        businessInfo: this.$store.state.signUpState.recorded.businessInfo,
        businessName: this.$store.state.signUpState.recorded.businessInfo.businessName,
        feedbackAddressHandle: this.$store.state.signUpState.recorded.feedbackAddressHandle
      }

      if (isAgencyAddingClient) {
        //Agency adding a new client, record who the agency's main entity uid[0] is
        entityDetail.agencyParent =  Array.isArray(this.$store.getters['dash/agency'].agencyEntityDocID) ? this.$store.getters['dash/agency'].agencyEntityDocID[0] : this.$store.getters['dash/agency'].agencyEntityDocID
      } else {
        //THIS IS A DOG SHOW IF THIS THING IS CREATED AND OVERWRITES THE EXISTING ACCOUNT
        if (this.$route.name === 'addnewclient') {
          window.location.href = 'https://feedack.link/dash/home'
          //console.log('new client error')
          return
        }
      }

      let gMaps = ''

      if (this.$store.state.signUpState.recorded.socialMediaReviews.googleMaps !== '') {

        // delete objects with functions for storage in DB:
        gMaps = { ...this.$store.state.signUpState.recorded.socialMediaReviews.googleMaps }

      }

      /*
      Done on BE:
      let authUIDDetail = {
        entityDocID: genBusId,
        ...userInfo
      }*/

      entityDetail.needHelp = {
        logoColor: this.$store.state.signUpState.recorded.needHelpLogoColor,
        socialMediaReviews: this.$store.state.signUpState.recorded.needHelpSocialReviews
      }

      let socialMedia = this.$store.state.signUpState.recorded.socialMediaReviews
      delete socialMedia.gMaps

      let publicFeedbackDetail = {
        //uAccess: this.genRandomUID(userID),
        entityInfo: this.$store.state.signUpState.recorded.businessInfo,
        socialMedia: {
          ...socialMedia,
          //PROVISIONING FOR MANUAL SETUP BY US:
          CTActivated: null,
          FSActivated: null,
          FbRActivated: null,
          FbSActivated: null,
          G2Activated: null,
          GPActivated: null,
          TAActivated: null,
          TPActivated: null,
          TwActivated: null,
          yeActivated: null,
          googleMaps: gMaps
        },
        feedbackAddressHandle: this.$store.state.signUpState.recorded.feedbackAddressHandle,
        //businessID: genBusId,
        appearanceInfo: this.$store.state.signUpState.recorded.appearance,
        activeQuestions: []
      }

      publicFeedbackDetail.dateCreated = new Date().getTime() / 1000

      //noconsoleconsole.log('SETTING APPEARANCE INFO WITH:')
      //noconsoleconsole.log(this.$store.state.signUpState.recorded.appearance)
      // WRITE AUTH > BUSSID RECORD FIRST - PERMISSIONS: DOC == AUTH AND DOC.SIZE = 1 AND 1 STRING FIELD (NO DELETE and NO UPDATE), only overwrite
      // IS OVERWRITE THE SAME AS UPDATE THOUGH?

      // THEN, YOU CANT CREATE A NEW ENTITY IF THE ENTITY YOUR CREATING IS NOT BUSSID OF YOUR AUTH DOC IN AUTHTOBUSSID
      // THEN, YOU CANT CREATE A NEW XXXX IF "

      let signupDetail = {
        signupLanguageChoice: this.$store.state.signUpState.recorded.signupLanguageChoice,
        entityDetail,
        userInfo,
        isAgencyAddingClient,
        publicFeedbackDetail,
        retryAppSumoCode: this.retryAppSumoCode
      }

      /*

      233
      219

      */

      let isMulti = false

      if (this.$route.name === 'addnew') {

        //THIS IS EITHER A business adding a new location or an agency adding a location for a client

        isMulti = true
        signupDetail.multi = true
        let currentMultis = []
        if ( typeof this.$store.state.dash.viewData.business.multi !== 'undefined' ) {
            currentMultis = this.$store.state.dash.viewData.business.multi
          } else {
            currentMultis = [this.$store.state.dash.viewData.business.businessID]
          }
        signupDetail.currentMultis = currentMultis

        if (typeof this.$store.state.dash.viewData.business.agencyParent !== 'undefined') {
          //we're creating a location for the client
          if (this.$store.getters['dash/agency'].isClientName) {
            signupDetail.isClientLocation = {
              clientID: this.$store.getters['dash/agency'].clientAuthDoc.clientID
            }
          } else {
            this.$vs.dialog({
              color: 'dark',
              acceptText: 'Ok',
              accept: () => {
                window.location.href = 'https://feedback.link/dash/home'
              },
              cancel: () => {
                window.location.href = 'https://feedback.link/dash/home'
              },
              title: `Oh no!`,
              text: 'We couldn\'t add your location. Please try again, or reach out to support with the code \'al\' - support@feedback.link'
            })
            return
          }
        } else {
          if (this.$store.getters['dash/agency'].isClientName) {
              //something wrong, don't continue
              this.$vs.dialog({
                color: 'dark',
                acceptText: 'Ok',
                accept: () => {
                  window.location.href = 'https://feedback.link/dash/home'
                },
                cancel: () => {
                  window.location.href = 'https://feedback.link/dash/home'
                },
                title: `Oh no!`,
                text: 'We couldn\'t add your location. Please try again, or reach out to support with the code \'al\' - support@feedback.link'
              })
              return
          }
        }
      }

      entityDetail.is2020 = true
      publicFeedbackDetail.is2020 = true

      //noconsoleconsole.log(publicFeedbackDetail)

      //noconsoleconsole.log('signing up')
      this.$vs.loading()

      let toCall = isMulti ? addNewLocation : signUp

      //noconsoleconsole.log('adding new location:' + isMulti)

      //noconsoleconsole.log(signupDetail)

      //return
 

      //console.log('calling')
      //console.log(signupDetail)
      //return

      toCall(signupDetail).then((result) => {
          //noconsoleconsole.log('signed up, result:')
          //noconsoleconsole.log(result)
          if (result.data.signedUp === true) {

            if (isMulti) {


              //This was an agency adding location for a client
              // OR
              //This was a normal account adding location for themselves


              //window.href.location = 'https://feedback.link/dash/home'
              let url = window.location.href
              let arr = url.split("/");
              window.location.href = arr[0] + '//' + arr[2] + '/dash/home?e=' + result.data.eID
            } else {

              
              //This was an agency adding a client
              // OR
              //This was a normal account signing up their first time                                                 

              let dbName = this.$store.state.auth.firebaseUser.displayName === null ? '' : this.$store.state.auth.firebaseUser.displayName                            
                
                if (isAgencyAddingClient) {
                  let url = window.location.href
                  let arr = url.split("/");

                  //force refresh/reload:
                  window.location.href = arr[0] + '//' + arr[2] + '/dash/home?client=' + encodeURIComponent(result.data.newClientID)
                } else {

                  //no need to reload
                  this.$router.push('/dash/home')
                }
              
            }
            this.$vs.loading.close()

          } else {

            this.$vs.loading.close()

            if (result.data.appSumoCodeError) {

              this.showRetryAppSumoCode = true

            } else {

              this.$vs.dialog({
                color: 'dark',
                acceptText: 'Ok',
                title: `Oh no!`,
                text: 'We couldn\'t set up your Feedback Link. Please try again. Please email us at support@feedback.link if you still can\'t proceed.'
              })

            }
          }

        }).catch((e) => {
          //noconsoleconsole.log(e)
          this.$vs.loading.close()
          this.$vs.dialog({
            color: 'dark',
            acceptText: 'Ok',
            title: `Oh no!`,
            text: 'We couldn\'t set up your Feedback Link. Please try again. Please email us at support@feedback.link if you still can\'t proceed.'
          })
        })



    },
    nextCalled (){
      if (this.step === 3) {

        //noconsoleconsole.log('creating')
        this.createNewEntity()

      } else {
        this.step = this.step + 1
      }
    },
    backCalled (){
      this.step = this.step - 1
    }
  },
  created () {
    /*if (document.body.className.match('theme-semi-dark')){
      document.body.classList.remove('theme-semi-dark')
    }*/

    //SETUP IS BEING ENTERED, SO JUST ENTER FIREBASE INFO INTO RECORDED STATE
    if (this.$route.name === 'setup' || this.$route.name === 'addnewclient') {
        
      let user = auth.currentUser
      if (user) {
        let token = user.getIdToken(true).then((token) => {
            this.$store.commit('auth/SET_CURRENT_USER', {...user, token})
        })
        let userName = user.displayName
        if (userName.indexOf('|pt_aSCI') !== -1) {
          userName = userName.substr(0,userName.indexOf('|pt_aSCI'))
        }

        Beacon('identify', {
          name: userName,
          email: user.email
        })


      }
    } else {
      //we're in add new location

      this.$store.commit('LOAD_ADDNEW_STATE')

    }



    document.body.classList.add('whitebody')
  },

  destroyed () {
    document.body.classList.remove('whitebody')
  }

}

</script>


<style lang="scss">


.icnbg {
    background: url('~@/assets/images/misc/subg.png');
    background-size: 910px 883px;
    animation: spin 200s ease-in infinite;
    //background-repeat: no-repeat;
    //background-origin: content-box;
  }


  @keyframes spin {
    50% { background-size: 1456px 1412.8px; }
  }
  @-webkit-keyframes spin {
    50% { background-size: 1456px 1412.8px; }
  }

</style>